import { atom } from "recoil";


export const mapBearingState = atom<number>({
    key: "mapBearingState",
    default: 0,
});
